// const base="http://localhost/officeops/";
const base="https://app.untraoffice.com/api/";
export const urls = {
    base:base,
    dashboard:base+"dashboardHandler",
    profile:base+"profileHandler",
    role:base+"roleHandler",
    task:base+"taskHandler",
    staff:base+"staffHandler",
    customer:base+"customerHandler",
    business:base+"businessHandler",
    transactions:base+"transactionsHandler",
    logout:base+"logout",
    schedule:base+"scheduleHandler",
    vendor:base+"vendorHandler",
};